/**
 * Get the current window.location and clean it up, returning only the
 * origin and pathname part of the URL.
 * @returns {string} - A new URL string that only
 * contains the origin and the pathname, removing all query
 * strings and hashes
 */
export function getDefaultUrl() {
  return cleanUrl(window.location.href);
}
/**
 * Clean up an URL and remove all the cruft that is being added by the
 * native apps.
 * @param url
 * @returns {string} - A new URL string that only
 * contains the origin and the pathname, removing all query
 * strings and hashes
 */

export function cleanUrl(url) {
  var loc = new URL(url); // Completely reconstruct the URL from it's parts

  return "".concat(loc.origin).concat(loc.pathname);
}